<template>
  <Select
    :items="documentos"
    :selectedItem="filter.documento"
    :label="$i18n('interface.payment_method')"
    searchPlaceholder="Buscar forma de pagamento"
    @atualizar="atualizar"
    :filtro_id="filtro.filtro"
    :path="path"
  />
</template>
<script>
import Select from '../../components/Select.vue';
export default {
  components: {
    Select,
  },
  props: {
    filtro: {
      type: Object,
      required: true,
    },
    path: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      filter: {
        documento: {
          id: "",
          name: "",
        },
      },
      documentos: [],
    };
  },
  methods: {
    atualizar(documento) {
      this.filter.documento = documento || { id: "", name: "" };

      const valor = this.filter.documento.id;
      this.$aplicaFiltroEmURL(this.filtro.filtro, valor, this.path);
      this.$store.commit('addFiltro', this.filtro);
      this.$store.commit('addFiltroAplicado', {
        filtro: this.filtro.filtro,
        valor: valor
      });
    },
  },
  mounted() {
    this.$api.get('/documentos/validos_para_nfe').then((response) => {
      this.documentos = response.data.map(doc => ({
        id: doc.codigo_nfe,
        name: doc.descricao
      }));

      const filtroAplicado = this.$store.state.filtroAplicados[this.filtro.filtro];
      this.$renderFiltroSelect(filtroAplicado, this.documentos, this.filter.documento);
    }).catch(error => exibe_erro(error.response?.data?.message || error.message));
  },
}
</script>
